window.Handlebars = require('handlebars');
var _ = require('lodash');

$(function(){
    window.autosize($('.comment__textarea'));
    $('body').on('click','.refresh__game',function(e){
        e.preventDefault();
        var $this = $(this);
        $this.addClass('disabled');
        $this.prepend('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> ');
        $this.find('i.fa-refresh').css('display','none');
		$.ajax({
			url:$this.attr('href'),
			type:'GET',
			success:function(json){
                if(json.status){
                    $this.removeClass('disabled');
                    $this.find('i.fa-spin').remove();
                    $this.prepend('<i class="fa fa-check"></i> ');
                    setTimeout(function(){
                        $this.find('i.fa-refresh').remove();
                        $this.find('i.fa-check').remove();
                        $this.attr('href',json.start_url);
                        $this.removeClass('refresh__game');
                        $this.prepend('<i class="fa fa-gamepad"></i> ');
                        }, 1000);
                }else{
                    alert(json.error);
                    $this.removeClass('disabled');
                    $this.find('i.fa-spin').remove();
                    $this.find('i.fa-refresh').css('display','inherit');
                }
			},
			error:function(){
				$this.removeClass('disabled');
				$this.find('i.fa-spin').remove();
				$this.prepend('<i class="fa fa-close"></i> ');
				setTimeout(function(){
                    $this.find('i.fa-close').remove();
                    $this.find('i.fa-refresh').css('display','inherit');
					}, 1000);

			}
		})
    })
 
    $('body').on('click','.notification__item',function(e){
        var $this = $(this);
        $.ajax({
            url:$this.data('url'),
            type:'POST',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            success: function(response){
                
            },
        });
    });

    $('#notifications').on('show.bs.dropdown', function () {
        var $this = $(this);
        $.ajax({
            url:$this.data('notifications-url'),
            success: function(response){
                $('.notifications__list').html(response);
            },
        });
        
    });

    // $.ajaxSetup({
    //     headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
    // });
    
    $('body').on('click','.btn-danger',function(e){
            if(!$(this).hasClass('not-confirm'))
                return confirm("Вы уверены?");
    });


    $('body').on('click','.trash__button',function(e) {
        e.preventDefault();
        if(confirm('Вы уверены?')){
            $(this).parents('.input__block').remove();
        }
    });
    

    if(typeof window.sortableURL !='undefinde') {
        $('.dd-dictionary').nestable({maxDepth: 1}).on('change', function (e) {
            $.ajax({
                url:window.sortableURL,
                type:'POST',
                data:{data:$(e.target).nestable('serialize')},
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                success:function(json){
                },
                error:function(error){
                    alert(error.statusText);
                }
            });
        });
    }


    $("body").on("change",".custom-file-input", function() {
        var fileName = $(this).val().split("\\").pop();
        $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
    });
    
    $('body').on('click','.user__select',function(){
        var $this = $(this);
        var $parent = $(this).parents('.search__div');
        var $result = $parent.find('.search__result');
        var $input = $parent.find('.find__user');
        $result.removeClass('show');
        $input.val($this.data('email'));
    })

    $('body').on('keyup','.find__user', _.debounce(function(e){
        var $this = $(this);
        var $parent = $(this).parents('.search__div');
        var $result = $parent.find('.search__result');
        if($this.val().length>3){
            $.ajax({
                url:$this.data('url'),
                method:'GET',
                data:{ q:$this.val() },
                success: function(json){
                    if(json.status){
                        if(json.users.length){
                            $result.empty();
                            json.users.forEach(function(item){
                                $result.append('<li class="no-after peers fxw-nw ai-c lh-1 user__select" data-email="'+item.email+'">'+
                                    '<div class="peer mR-10">'+
                                        '<div class="w-3r h-3r bdrs-50p ps" style="background: url('+item.avatar+');background-size: cover;background-position: 50% 50%;"></div>'+
                                    '</div>'+
                                    '<div class="peer">'+
                                        '<span class="fsz-sm c-grey-900 d-block">'+item.name+'</span>'+
                                        '<span class="fsz-sm c-grey-700 d-block mT-10">'+item.email+'</span>'+
                                        '<span class="fsz-sm c-grey-700 d-block mT-10">'+item.phone+'</span>'+
                                    '</div>'+
                                '</li>');
                                $result.addClass('show');
                            })
                        }else{
                            $result.removeClass('show');
                        }
                    }
                },
                error: function(){
                    $result.removeClass('show');
                }
            })
        }else{
            $result.removeClass('show');
        }
    },300));

    if(typeof window.uploadUrl != 'underfind'){
        if($('#inputTextClassic').length){
            window.ClassicEditor.create( document.querySelector( '#inputTextClassic' ) ,{

                mediaEmbed:{
                    previewsInData:true
                },
                image: {
                    toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
        
                    styles: [
                        'full',
                        'alignLeft',
                        'alignRight'
                    ]
                },
                ckfinder: {
                    uploadUrl: window.uploadUrl
                }
            });
            
        }
    }
});